export enum Category {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business',
}
